<template>
    <footer class="footer">
        <div class="footer-top">
            <div class="container">
                <!-- <div class="footer-link-wrap">

                    <ul class="footer-link">
                        <li><a href="/company">회사소개</a></li>
                        <li><a href="/policy">이용약관</a></li>
                        <li><a href="/privacy">개인정보 취급방침</a></li>
                        <li><a href="/company#green">친환경벽지</a></li>
                    </ul>
                </div> -->
                <!-- <div class="f-right-logo"><img src="/images/main/f-logo.png" alt=""></div> -->
                <ul class="footer-right">
                    <!-- <li><a href="/lmpc/intro">DID LMPC</a></li> -->
                    <li><a href="https://www.didwallpaper.com/" target="_blank">KOREAN</a></li>
                </ul>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="container">
                <div class="footer-col">
                    <ul class="footer-info">
                        <li>10th, 12th floor, Gungdo Bldg, 327, Bongeunsa-ro, Gangnam-gu, Seoul, Republic of Korea</li>
                        <li>Tel. 02-2141-3930</li>
                        <li>E-mail. customer@didwallpaper.com</li>
                        <li>Business Registration Number. 220-85-09219</li>
                        <!-- <li>정보책임자 이돈영</li> -->
                        <li>Copyright (c) 2020 didwallpaper all right reserved.</li>
                    </ul>
                </div>
                <!-- <div class="footer-col">
                    <ul class="footer-customer">
                        <li><img src="/images/icon/footer-customer-chat.png" alt=""></li>
                    </ul>
                </div> -->
            </div>
        </div>
        <!-- <quick-menu></quick-menu> -->
    </footer>
</template>

<script>
import QuickMenu from "@/components/client/inc/quick-menu.vue";

export default {
    components: {
        QuickMenu
    }
}
</script>
